import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import RichEditor from "../../settings/components/RichEditor";
import FormInput from "../../../components/forms/FormInput";
import { RichEditorType } from "../../settings/components/RichEditorType";
import { prepareBodyForEditor } from "../../../utils/emailTemplateHtml";

interface FormData {
  subject: string;
  body: string;
  text_message_body?: string;
}

interface EditTemplateProps {
  show: boolean;
  onHide: () => void;
  data: FormData;
  onSubmit: (data: FormData) => void;
  title?: string;
  editorType?: RichEditorType;
  showSms?: boolean;
}

const schema = yup
  .object({
    subject: yup.string().required("Email Template name is required"),
    body: yup.string().required("Email Template body is required"),
    text_message_body: yup.string().optional(),
  })
  .required();

const EditTemplate: React.FC<EditTemplateProps> = ({
  show,
  onHide,
  data,
  onSubmit,
  title = "Edit Template",
  editorType = RichEditorType.REFERRAL,
  showSms = false,
}) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      subject: data.subject,
      body: prepareBodyForEditor(data.body),
      text_message_body: data.text_message_body ?? "",
    },
  });

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = methods;

  useEffect(() => {
    methods.reset({
      subject: data.subject,
      body: prepareBodyForEditor(data.body),
      text_message_body: data.text_message_body ?? "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, show]);

  return (
    <Offcanvas style={{ width: "600px" }} show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <FormProvider {...methods}>
            <div className="d-flex flex-column gap-3">
              <FormInput
                type="text"
                name="subject"
                label="Subject"
                register={register}
                errors={errors}
              />
              <Form.Group>
                <Form.Label>Email Body</Form.Label>
                <RichEditor key={`${editorType}-${show}-${data.subject}`} name="body" type={editorType} />
              </Form.Group>
              {showSms && (
                <Form.Group>
                  <Form.Label>Text Message Body</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="SMS / text message"
                    isInvalid={!!errors.text_message_body}
                    {...register("text_message_body")}
                  />
                  {errors.text_message_body && (
                    <Form.Control.Feedback type="invalid">
                      {errors.text_message_body.message}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              )}
            </div>
            <div className="d-flex justify-content-end mt-3">
              <button className="btn btn-primary">Save</button>
            </div>
          </FormProvider>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EditTemplate;
